function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { actions as appActions } from '#reducers/app.reducer';
import ContactUsForm from './ContactUsForm.react';
var ContactUsPopup = function ContactUsPopup(_ref) {
  var isOpen = _ref.isOpen;
  var dispatch = useDispatch();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isValid = _useState2[0],
    setIsValid = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isSent = _useState4[0],
    setIsSent = _useState4[1];
  var _useState5 = useState({
      name: '',
      phoneNumber: '',
      message: ''
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    form = _useState6[0],
    setForm = _useState6[1];
  useEffect(function () {
    var _form$name, _form$phoneNumber, _form$message;
    setIsValid(((_form$name = form.name) === null || _form$name === void 0 ? void 0 : _form$name.length) > 0 && ((_form$phoneNumber = form.phoneNumber) === null || _form$phoneNumber === void 0 ? void 0 : _form$phoneNumber.length) > 0 && ((_form$message = form.message) === null || _form$message === void 0 ? void 0 : _form$message.length) > 0);
  }, [form]);
  useEffect(function () {
    if (isOpen) {
      $('.contact-us-popup').css({
        display: 'flex'
      });
      setTimeout(function () {
        $('.contact-us-popup').css({
          opacity: 1
        });
      }, 10);
    } else {
      $('.contact-us-popup').css({
        opacity: 0
      });
      setTimeout(function () {
        $('.contact-us-popup').css({
          display: 'none'
        });
      }, 110);
    }
    if (!isOpen) {
      setIsSent(false);
      setForm({
        name: '',
        phoneNumber: '',
        message: ''
      });
    }
  }, [isOpen]);
  useEffect(function () {
    if (!isSent) return;
    $('.contact-us-popup__validation').css({
      opacity: 1
    });
  }, [isSent]);
  var handleOnSend = function handleOnSend() {
    dispatch({
      type: appActions.contactUsBubble,
      payload: _objectSpread(_objectSpread({}, form), {}, {
        app: 'washplant'
      })
    });
    setIsSent(true);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: ['contact-us-popup'].join(' ')
  }, /*#__PURE__*/React.createElement("div", {
    className: "contact-us-popup__header"
  }, "Get a quick response via text"), /*#__PURE__*/React.createElement("div", {
    className: "contact-us-popup__body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "contact-us-popup__body--info"
  }, "Enter your information, and our team will text you shortly."), /*#__PURE__*/React.createElement(ContactUsForm, {
    form: form,
    setForm: setForm
  }), /*#__PURE__*/React.createElement("div", {
    className: "contact-us-popup__body--legal"
  }, "By submitting, you authorize Posillico Materials to text/call the number above possibly using automated means &/or AI-generated calls/content."), isSent ? /*#__PURE__*/React.createElement("div", {
    className: "contact-us-popup__validation"
  }, "Thank you for reaching out!") : null), /*#__PURE__*/React.createElement("div", {
    className: "contact-us-popup__footer"
  }, /*#__PURE__*/React.createElement("button", {
    disabled: !isValid || isSent,
    onClick: handleOnSend
  }, "Send")));
};
export default ContactUsPopup;